// Translations for public check-in form (HR/EN/DE/IT)
export const FORM_TRANSLATIONS = {
  hr: {
    title: "Prijava gostiju",
    subtitle: "Molimo popunite sve podatke za prijavu u eVisitor sustav",
    legal_intro: "Ova forma služi za zakonski obveznu prijavu turista u sustav eVisitor sukladno Zakonu o turističkoj pristojbi Republike Hrvatske.",
    privacy_link: "Politika privatnosti",
    important: "Važno: Dodajte SVE goste koji dolaze u apartman. Svaka osoba mora biti prijavljena.",
    consent: 'Klikom na gumb "Pošalji prijavu" potvrđujete da su uneseni podaci točni te pristajete na njihovu obradu i prosljeđivanje u sustav eVisitor (Hrvatska turistička zajednica i Ministarstvo unutarnjih poslova) u svrhu ispunjavanja zakonske obveze prijave turista.',
    add_guest: "+ Dodaj još gosta",
    submit: (n) => `Pošalji prijavu (${n} ${n === 1 ? "gost" : "gostiju"})`,
    submitting: "Šaljem…",
    success_title: "Hvala — prijava poslana!",
    success_subtitle: "Pružatelj smještaja je zaprimio vaše podatke. Hvala što ste izabrali boravak kod nas. Sretan boravak!",
    fields: {
      first_name: "Ime", last_name: "Prezime",
      date_of_birth: "Datum rođenja", gender: "Spol",
      gender_m: "Muški", gender_f: "Ženski", gender_select: "Odaberite spol",
      citizenship: "Državljanstvo", country_of_birth: "Država rođenja", city_of_birth: "Grad rođenja",
      document_type: "Vrsta dokumenta", document_number: "Broj dokumenta",
      country_of_residence: "Država prebivališta", city_of_residence: "Grad prebivališta",
      arrival: "Datum i vrijeme dolaska", departure: "Datum i vrijeme odlaska",
      checkin_from: "Check-in od", checkout_until: "Check-out do",
      select_date: "Odaberite datum", select_country: "Odaberite državu",
      select_doc: "Odaberite vrstu dokumenta",
      doc_passport: "Putovnica", doc_id: "Osobna iskaznica", doc_driver: "Vozačka dozvola",
      guest_index: (n) => `Gost ${n}`,
      remove_guest: "Ukloni",
      lead_guest_label: "Nositelj rezervacije",
    },
    privacy: {
      back: "Natrag",
      title: "POLITIKA PRIVATNOSTI",
      subtitle: "eVisitor check-in sustav",
      h1: "1. Voditelj obrade osobnih podataka",
      h1_body: (e) => `Voditelj obrade osobnih podataka je ${e.company_name || e.responsible_person || "—"}${e.oib ? `, OIB: ${e.oib}` : ""}${e.address ? `, ${e.address}` : ""}${e.city ? `, ${e.city}` : ""}, koji pruža usluge smještaja i koristi ovaj sustav za prijavu turista u skladu sa zakonskim obvezama Republike Hrvatske.`,
      h2: "2. Svrha obrade osobnih podataka",
      h2_body: ["ispunjavanja zakonske obveze prijave turista u sustav eVisitor", "vođenja evidencije gostiju sukladno važećim propisima", "olakšavanja i ubrzavanja procesa prijave gosta (self check-in)"],
      h3: "3. Kategorije osobnih podataka",
      h3_body: ["ime i prezime", "datum rođenja", "spol", "državljanstvo", "država i grad rođenja", "vrsta i broj identifikacijskog dokumenta", "država i grad prebivališta", "datum i vrijeme dolaska", "datum i vrijeme odlaska"],
      h5: "5. Primatelji osobnih podataka",
      h5_body: "Osobni podaci se prosljeđuju Hrvatskoj turističkoj zajednici i Ministarstvu unutarnjih poslova putem sustava eVisitor radi ispunjavanja zakonske obveze.",
      h7: "7. Rok čuvanja podataka",
      h7_body: "Podaci u sustavu eVisitor čuvaju se sukladno zakonskim propisima (do 10 godina). Podaci u ovom sustavu čuvaju se samo onoliko dugo koliko je nužno za izvršenje zakonske obveze.",
      h8: "8. Sigurnost podataka",
      h8_body: ["HTTPS enkripcija za sav promet", "JWT autentifikacija", "hashiranje lozinki (bcrypt)", "Fernet enkripcija eVisitor vjerodajnica", "višekorisnička (multi-tenant) arhitektura"],
      h10: "10. Prava ispitanika",
      h10_body: ["pristup osobnim podacima", "ispravak netočnih podataka", "ograničenje obrade", "prigovor na obradu", "podnošenje pritužbe nadzornom tijelu (AZOP)"],
      h12: "12. Kontakt",
      controllers_title: "Voditelji obrade po smještaju",
      controllers_empty: "Voditelj obrade nije konfiguriran. Kontaktirajte pružatelja smještaja za detalje.",
      supervisory: "Nadzorno tijelo: Agencija za zaštitu osobnih podataka (AZOP), Selska cesta 136, 10000 Zagreb — www.azop.hr",
    },
  },
  en: {
    title: "Guest registration",
    subtitle: "Please fill in all the data for registration in the eVisitor system",
    legal_intro: "This form is used for the legally required registration of tourists in the eVisitor system in accordance with the Tourist Tax Act of the Republic of Croatia.",
    privacy_link: "Privacy policy",
    important: "Important: Add ALL guests who will be staying. Each person must be registered.",
    consent: 'By clicking "Send registration", you confirm that the entered data is accurate and agree to its processing and forwarding to the eVisitor system (Croatian National Tourist Board and Ministry of Interior) for the purpose of fulfilling the legal obligation to register tourists.',
    add_guest: "+ Add another guest",
    submit: (n) => `Send registration (${n} guest${n === 1 ? "" : "s"})`,
    submitting: "Sending…",
    success_title: "Thank you — registration submitted!",
    success_subtitle: "Your host has received your data. Thank you for choosing to stay with us. Enjoy your stay!",
    fields: {
      first_name: "First name", last_name: "Last name",
      date_of_birth: "Date of birth", gender: "Gender",
      gender_m: "Male", gender_f: "Female", gender_select: "Select gender",
      citizenship: "Citizenship", country_of_birth: "Country of birth", city_of_birth: "City of birth",
      document_type: "Document type", document_number: "Document number",
      country_of_residence: "Country of residence", city_of_residence: "City of residence",
      arrival: "Arrival date & time", departure: "Departure date & time",
      checkin_from: "Check-in from", checkout_until: "Check-out by",
      select_date: "Select date", select_country: "Select country",
      select_doc: "Select document type",
      doc_passport: "Passport", doc_id: "ID card", doc_driver: "Driver's licence",
      guest_index: (n) => `Guest ${n}`,
      remove_guest: "Remove",
      lead_guest_label: "Lead guest",
    },
    privacy: {
      back: "Back",
      title: "PRIVACY POLICY",
      subtitle: "eVisitor check-in system",
      h1: "1. Data controller",
      h1_body: (e) => `The data controller is ${e.company_name || e.responsible_person || "—"}${e.oib ? `, OIB: ${e.oib}` : ""}${e.address ? `, ${e.address}` : ""}${e.city ? `, ${e.city}` : ""}, who provides accommodation services and uses this system to register tourists in accordance with the legal obligations of the Republic of Croatia.`,
      h2: "2. Purpose of processing personal data",
      h2_body: ["fulfilling the legal obligation to register tourists in the eVisitor system", "keeping a guest register in accordance with applicable regulations", "facilitating and speeding up the guest check-in process"],
      h3: "3. Categories of personal data",
      h3_body: ["first name and last name", "date of birth", "gender", "citizenship", "country and city of birth", "type and number of ID document", "country and city of residence", "arrival date and time", "departure date and time"],
      h5: "5. Recipients of personal data",
      h5_body: "Personal data is forwarded to the Croatian National Tourist Board and the Ministry of Interior via the eVisitor system in order to fulfil the legal obligation.",
      h7: "7. Data retention period",
      h7_body: "Data in the eVisitor system is retained in accordance with legal regulations (up to 10 years). Data in this system is retained only as long as necessary to fulfil the legal obligation.",
      h8: "8. Data security",
      h8_body: ["HTTPS encryption for all traffic", "JWT authentication", "password hashing (bcrypt)", "Fernet encryption of eVisitor credentials", "multi-tenant architecture"],
      h10: "10. Data subject rights",
      h10_body: ["access to personal data", "correction of inaccurate data", "restriction of processing", "objection to processing", "filing a complaint with the supervisory authority (AZOP)"],
      h12: "12. Contact",
      controllers_title: "Data controllers per accommodation",
      controllers_empty: "Data controller is not configured. Contact the accommodation provider for details.",
      supervisory: "Supervisory authority: Croatian Personal Data Protection Agency (AZOP), Selska cesta 136, 10000 Zagreb — www.azop.hr",
    },
  },
  de: {
    title: "Gästeanmeldung",
    subtitle: "Bitte füllen Sie alle Daten für die Anmeldung im eVisitor-System aus",
    legal_intro: "Dieses Formular dient der gesetzlich vorgeschriebenen Anmeldung von Touristen im eVisitor-System gemäß dem Gesetz über die Kurtaxe der Republik Kroatien.",
    privacy_link: "Datenschutzerklärung",
    important: "Wichtig: Fügen Sie ALLE Gäste hinzu, die im Apartment ankommen. Jede Person muss separat angemeldet werden.",
    consent: 'Mit Klick auf "Anmeldung senden" bestätigen Sie, dass die eingegebenen Daten korrekt sind, und stimmen deren Verarbeitung und Weiterleitung an das eVisitor-System (Kroatischer Tourismusverband und Innenministerium) zur Erfüllung der gesetzlichen Verpflichtung zur Touristenanmeldung zu.',
    add_guest: "+ Weiteren Gast hinzufügen",
    submit: (n) => `Anmeldung senden (${n} Gast${n === 1 ? "" : "e"})`,
    submitting: "Sende…",
    success_title: "Danke — Anmeldung gesendet!",
    success_subtitle: "Ihr Gastgeber hat Ihre Daten erhalten. Danke, dass Sie sich für einen Aufenthalt bei uns entschieden haben. Schönen Aufenthalt!",
    fields: {
      first_name: "Vorname", last_name: "Nachname",
      date_of_birth: "Geburtsdatum", gender: "Geschlecht",
      gender_m: "Männlich", gender_f: "Weiblich", gender_select: "Geschlecht wählen",
      citizenship: "Staatsangehörigkeit", country_of_birth: "Geburtsland", city_of_birth: "Geburtsort",
      document_type: "Dokumenttyp", document_number: "Dokumentnummer",
      country_of_residence: "Wohnsitzland", city_of_residence: "Wohnort",
      arrival: "Anreisedatum & -zeit", departure: "Abreisedatum & -zeit",
      checkin_from: "Check-in ab", checkout_until: "Check-out bis",
      select_date: "Datum wählen", select_country: "Land wählen",
      select_doc: "Dokumenttyp wählen",
      doc_passport: "Reisepass", doc_id: "Personalausweis", doc_driver: "Führerschein",
      guest_index: (n) => `Gast ${n}`,
      remove_guest: "Entfernen",
      lead_guest_label: "Hauptgast",
    },
    privacy: {
      back: "Zurück",
      title: "DATENSCHUTZERKLÄRUNG",
      subtitle: "eVisitor Check-in-System",
      h1: "1. Verantwortlicher",
      h1_body: (e) => `Verantwortlicher ist ${e.company_name || e.responsible_person || "—"}${e.oib ? `, OIB: ${e.oib}` : ""}${e.address ? `, ${e.address}` : ""}${e.city ? `, ${e.city}` : ""}, der Unterkunftsdienste anbietet und dieses System zur Anmeldung von Touristen gemäß den gesetzlichen Verpflichtungen der Republik Kroatien nutzt.`,
      h2: "2. Zweck der Verarbeitung",
      h2_body: ["Erfüllung der gesetzlichen Verpflichtung zur Touristenanmeldung im eVisitor-System", "Führung eines Gästeverzeichnisses gemäß geltenden Vorschriften", "Erleichterung des Check-in-Prozesses"],
      h3: "3. Kategorien personenbezogener Daten",
      h3_body: ["Vor- und Nachname", "Geburtsdatum", "Geschlecht", "Staatsangehörigkeit", "Geburtsland und -ort", "Art und Nummer des Ausweisdokuments", "Wohnsitzland und -ort", "Anreisedatum und -zeit", "Abreisedatum und -zeit"],
      h5: "5. Empfänger der Daten",
      h5_body: "Die personenbezogenen Daten werden zur Erfüllung der gesetzlichen Verpflichtung an den Kroatischen Tourismusverband und das Innenministerium über das eVisitor-System weitergeleitet.",
      h7: "7. Speicherdauer",
      h7_body: "Daten im eVisitor-System werden gemäß den gesetzlichen Vorschriften aufbewahrt (bis zu 10 Jahre).",
      h8: "8. Datensicherheit",
      h8_body: ["HTTPS-Verschlüsselung", "JWT-Authentifizierung", "Passwort-Hashing (bcrypt)", "Fernet-Verschlüsselung der eVisitor-Anmeldedaten", "Mandantenfähige Architektur"],
      h10: "10. Rechte der betroffenen Person",
      h10_body: ["Zugang zu personenbezogenen Daten", "Berichtigung", "Einschränkung der Verarbeitung", "Widerspruch", "Beschwerde bei der Aufsichtsbehörde (AZOP)"],
      h12: "12. Kontakt",
      controllers_title: "Verantwortliche pro Unterkunft",
      controllers_empty: "Kein Verantwortlicher konfiguriert.",
      supervisory: "Aufsichtsbehörde: AZOP, Selska cesta 136, 10000 Zagreb — www.azop.hr",
    },
  },
  it: {
    title: "Registrazione ospiti",
    subtitle: "Si prega di compilare tutti i dati per la registrazione nel sistema eVisitor",
    legal_intro: "Questo modulo è utilizzato per la registrazione legalmente obbligatoria dei turisti nel sistema eVisitor in conformità con la Legge sulla tassa di soggiorno della Repubblica di Croazia.",
    privacy_link: "Informativa sulla privacy",
    important: "Importante: Aggiungere TUTTI gli ospiti che alloggeranno. Ogni persona deve essere registrata.",
    consent: 'Cliccando su "Invia registrazione", confermi che i dati inseriti sono corretti e accetti il loro trattamento e trasmissione al sistema eVisitor (Ente Nazionale Croato per il Turismo e Ministero dell\'Interno) ai fini dell\'adempimento dell\'obbligo legale di registrazione dei turisti.',
    add_guest: "+ Aggiungi altro ospite",
    submit: (n) => `Invia registrazione (${n} ospit${n === 1 ? "e" : "i"})`,
    submitting: "Invio…",
    success_title: "Grazie — registrazione inviata!",
    success_subtitle: "Il tuo host ha ricevuto i tuoi dati. Grazie per aver scelto di soggiornare con noi. Buon soggiorno!",
    fields: {
      first_name: "Nome", last_name: "Cognome",
      date_of_birth: "Data di nascita", gender: "Sesso",
      gender_m: "Maschio", gender_f: "Femmina", gender_select: "Seleziona sesso",
      citizenship: "Cittadinanza", country_of_birth: "Paese di nascita", city_of_birth: "Città di nascita",
      document_type: "Tipo di documento", document_number: "Numero documento",
      country_of_residence: "Paese di residenza", city_of_residence: "Città di residenza",
      arrival: "Data e ora di arrivo", departure: "Data e ora di partenza",
      checkin_from: "Check-in da", checkout_until: "Check-out entro",
      select_date: "Seleziona data", select_country: "Seleziona paese",
      select_doc: "Seleziona tipo di documento",
      doc_passport: "Passaporto", doc_id: "Carta d'identità", doc_driver: "Patente di guida",
      guest_index: (n) => `Ospite ${n}`,
      remove_guest: "Rimuovi",
      lead_guest_label: "Ospite principale",
    },
    privacy: {
      back: "Indietro",
      title: "INFORMATIVA SULLA PRIVACY",
      subtitle: "Sistema di check-in eVisitor",
      h1: "1. Titolare del trattamento",
      h1_body: (e) => `Il titolare del trattamento è ${e.company_name || e.responsible_person || "—"}${e.oib ? `, OIB: ${e.oib}` : ""}${e.address ? `, ${e.address}` : ""}${e.city ? `, ${e.city}` : ""}, che fornisce servizi di alloggio e utilizza questo sistema per registrare i turisti in conformità con gli obblighi legali della Repubblica di Croazia.`,
      h2: "2. Finalità del trattamento",
      h2_body: ["adempimento dell'obbligo legale di registrazione dei turisti nel sistema eVisitor", "tenuta del registro degli ospiti", "facilitazione del processo di check-in"],
      h3: "3. Categorie di dati personali",
      h3_body: ["nome e cognome", "data di nascita", "sesso", "cittadinanza", "paese e città di nascita", "tipo e numero del documento", "paese e città di residenza", "data e ora di arrivo", "data e ora di partenza"],
      h5: "5. Destinatari",
      h5_body: "I dati personali vengono trasmessi all'Ente Nazionale Croato per il Turismo e al Ministero dell'Interno tramite il sistema eVisitor.",
      h7: "7. Periodo di conservazione",
      h7_body: "I dati nel sistema eVisitor sono conservati secondo i regolamenti legali (fino a 10 anni).",
      h8: "8. Sicurezza dei dati",
      h8_body: ["crittografia HTTPS", "autenticazione JWT", "hashing delle password (bcrypt)", "crittografia Fernet delle credenziali eVisitor", "architettura multi-tenant"],
      h10: "10. Diritti dell'interessato",
      h10_body: ["accesso ai dati personali", "rettifica", "limitazione del trattamento", "opposizione", "reclamo all'autorità di controllo (AZOP)"],
      h12: "12. Contatto",
      controllers_title: "Titolari del trattamento per alloggio",
      controllers_empty: "Titolare non configurato.",
      supervisory: "Autorità di controllo: AZOP, Selska cesta 136, 10000 Zagreb — www.azop.hr",
    },
  },
};

export const LANGUAGES = [
  { code: "hr", label: "HR", flag: "🇭🇷" },
  { code: "en", label: "EN", flag: "🇬🇧" },
  { code: "de", label: "DE", flag: "🇩🇪" },
  { code: "it", label: "IT", flag: "🇮🇹" },
];
